import moneyString from '../moneyString.js'

function buildTransferEvents (newTransfers, oldTransfers, cartId) {
  const transferEvents = []

  function matches (oneTransfer, anotherTransfer) {
    return oneTransfer.description == anotherTransfer.description
      &&  oneTransfer.type == anotherTransfer.type
      && oneTransfer.code == anotherTransfer.code
      && oneTransfer.total == anotherTransfer.total
  }

  function contains (listOfTransfers, aTransfer) {
    return listOfTransfers.reduce( (accumulator, aTransferFromTheList)=>{return accumulator||matches(aTransferFromTheList, aTransfer)}, false )
  }

  newTransfers.forEach((newTransfer)=>{
    if (!contains(oldTransfers, newTransfer)) {
      transferEvents.push(buildAddTransferEvent(newTransfer, cartId))
    }
  })

  oldTransfers.forEach((oldTransfer)=>{
    if (!contains(newTransfers, oldTransfer)) {
      transferEvents.push(buildRemoveTransferEvent(oldTransfer, cartId))
    }
  })

  return transferEvents
}

function buildAddTransferEvent (transfer, cartId) {
  return {
    event: 'addToCart',
    cart_lines: [createCartLineForTransfer(transfer, cartId)],
  }
}

function buildRemoveTransferEvent (transfer, cartId) {
  return {
    event: 'removeFromCart',
    cart_lines: [createCartLineForTransfer(transfer, cartId)],
  }
}

function createCartLineForTransfer (transfer, cartId) {
  const valueOfTransfer = moneyString(transfer.amount || transfer.total || 0)
  return {
    "cart_id": cartId,
    "value": valueOfTransfer,
    "product": {
      "id": `${transfer.code}`,
      "name": `${transfer.type}`,
      "category": "Extras/Transfers",
      "quantity": "1",
      "value": valueOfTransfer,
    },
  }
}

export default {
  eventsFor: (oldState, newState) => {

    const events = []

    if (oldState && oldState.priceBreakdown && newState && newState.priceBreakdown) {
      const transferEvents = buildTransferEvents(newState.priceBreakdown.transfers, oldState.priceBreakdown.transfers, newState.cart.cartId)
      transferEvents.forEach((event)=>{
        events.push(event)
      })
    }

    return events
  },
  cartLinesFor (currentState) {
    const cartLines = []

    if (currentState.cart.transfers && currentState.cart.transfers.length > 0) {
      const transfers = currentState.cart.transfers.map((transfer) => {
        return createCartLineForTransfer(transfer, currentState.cart.cartId)
      })

      transfers.forEach((transfer)=> {
        cartLines.push(transfer)
      })
    }

    return cartLines
  },
}